import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = ({ theme, fill }) => `
  background-color: ${theme.colors.status.success};
  height: 100%;
  width: ${fill};
  transition: width .2s ease-out;
`;

const themePropTypes = {
  colors: PropTypes.shape({
    status: PropTypes.shape({
      success: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const propTypes = {
  fill: PropTypes.string,
};

const defaultProps = {
  fill: '0%',
};

export default buildStyledComponent(
  'Bar',
  styled.div,
  styles,
  { propTypes, themePropTypes, defaultProps },
);



// WEBPACK FOOTER //
// ./components/ProgressBar/Bar.js